import { SeoItem } from './seo-item.model';

export interface HasSeoItem {
  getSeoItem(): SeoItem;
}

export function hasSeoItem(item: any): item is HasSeoItem {
  return (item as HasSeoItem).getSeoItem !== undefined;
}
